import { IWorkerInfoDTO } from "@interfaces/IWorkerInfoDTO";
import { iFormValues } from "@models/forms/iFormValues";
import axiosClient from "./axiosClient";
import { IEngagementStatusDTO } from "@interfaces/IEngagementStatusDTO";
import {
  IWorkerEngagementDTO,
  IWorkerEngagementUpsertDTO,
} from "@interfaces/IWorkerEngagementDTO";

export function createContractor(data: Partial<IWorkerInfoDTO>) {
  return axiosClient.post<{ status: string; data: { worker_id: number } }>(
    "/worker_api/worker/create",
    data
  );
}

export function fetchContractors(): Promise<IWorkerInfoDTO[]> {
  return axiosClient
    .get<IWorkerInfoDTO[]>("/worker_api/workers/all")
    .then((res) => res.data);
}

export function updateContractor(workerId: number, data: Partial<iFormValues>) {
  return axiosClient.put<{ status: string; worker_id: number }>(
    `/worker_api/api/workers/${workerId}`,
    data
  );
}
export function sendRegistrationEmail(workerId: number) {
  return axiosClient.post<{ status: string; worker_id: number }>(
    `/worker_api/worker/registration/${workerId}`
  );
}

export function fetchEngagementStatus(): Promise<IEngagementStatusDTO[]> {
  return axiosClient
    .get<IEngagementStatusDTO[]>("/worker_api/engagement/status/list")
    .then((res) => res.data);
}

export function fetchWorkerEngagements(
  workerId: number
): Promise<IWorkerEngagementDTO[]> {
  return axiosClient
    .get<IWorkerEngagementDTO[]>(`/worker_api/worker/${workerId}/engagements`)
    .then((res) => res.data);
}

export function createWorkerEngagement(
  workerId: number,
  data: IWorkerEngagementUpsertDTO
) {
  return axiosClient.post<{ status: string; engagement: IWorkerEngagementDTO }>(
    `/worker_api/worker/${workerId}/engagements`,
    data
  );
}

export function updateWorkerEngagementRecord(
  engagementId: number,
  data: Partial<IWorkerEngagementUpsertDTO>
) {
  return axiosClient.put<{ status: string; engagement: IWorkerEngagementDTO }>(
    `/worker_api/engagement/${engagementId}`,
    data
  );
}

// ...and any other CRUD calls...
